import { useFetch } from 'use-http';

const useUserService = () => {
    const { get: getRequest, response } = useFetch('/json-api/user');

    const getUserAndToken = async () => {
        const data = await getRequest();
        if (response.ok) {
            return data;
        }

        return false;
    };

    return {
        get: getUserAndToken,
    };
};

export default useUserService;
